<elder-basic-pane-layout class="full">
  <elder-pane>
    <app-facility-utilisation-viewer class="flex"> </app-facility-utilisation-viewer>
  </elder-pane>
</elder-basic-pane-layout>
